import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable()
export class BaseStore<T = unknown> {
	constructor(protected store: Store<T>) {}
}
